import { styled } from '@mui/material';
import { PWC } from '~/adapters/typescript/propsWithChildren';

const StyledSvg = styled('svg')(({ theme }) => ({
    height: 30,
    paddingRight: theme.spacing(2),
}));

export function IconSvg({ children }: PWC) {
    return <StyledSvg viewBox="0 0 40 24">{children}</StyledSvg>;
}
